import { Icon } from '../../components/ui/Icon'

export interface RfqEtaChipProps {
  /** The computed `YYYY-MM-DD` estimated-return date (`etaForRfq`, anchored on
   * `submittedAt ?? createdAt` — Gate-5 M2), or `null` when neither was
   * present/valid, in which case this renders nothing, never an
   * "Invalid Date". */
  readonly eta: string | null
}

/**
 * The orange clock chip shown on a `requested`/`quoting` RFQ card (UID-118,
 * design ref `Fictiv Platform.dc.html` L3043-3044): "Quote in progress · our
 * sourcing team is reviewing your files · estimated return {eta}".
 *
 * a11y (WCAG 2.2 AA, 1.4.1 "use of color"): the meaning here is carried by
 * the TEXT, not by the orange swatch — the clock icon is purely decorative
 * (`aria-hidden`, matching the `CheckOutlined`/`ShareAltOutlined` convention
 * elsewhere in this vertical) and the visible copy uses the app's ordinary
 * body-text color tokens, not orange. Static content (no polling, no async
 * state change after mount) so this deliberately carries no
 * `role="status"`/`aria-live` — those are for content that changes after
 * the user has already perceived it.
 */
export function RfqEtaChip({ eta }: RfqEtaChipProps) {
  if (!eta) return null

  return (
    <div className="rfq-eta-chip">
      <span className="rfq-eta-chip-icon">
        <Icon name="clock" />
      </span>
      <span className="rfq-eta-chip-text">
        <strong>Quote in progress</strong> · our sourcing team is reviewing your files · estimated
        return{' '}
        <strong>
          <time dateTime={eta}>{eta}</time>
        </strong>
      </span>
    </div>
  )
}
